import api from "@/console/apis/$api";
import aspida from "@aspida/axios";
import { axiosClient } from "@/console/app/client/axiosClient";

export const httpClient = api(aspida(axiosClient));
